export const sortByStartTime = (direction: "asc" | "desc" = "asc") => {
  return (a: { startTime?: string | null }, b: { startTime?: string | null }): number => {
    const aStart = a?.startTime ? new Date(a?.startTime) : new Date();
    const bStart = b.startTime ? new Date(b.startTime) : new Date();
    const aDate = new Date(aStart).valueOf();
    const bDate = new Date(bStart).valueOf();
    return direction === "asc" ? aDate - bDate : bDate - aDate;
  };
};
export const sortByTime = (direction: "asc" | "desc" = "asc") => {
  return (a: { time?: string | null }, b: { time?: string | null }): number => {
    const aStart = a?.time ? new Date(a?.time) : new Date();
    const bStart = b.time ? new Date(b.time) : new Date();
    const aDate = new Date(aStart).valueOf();
    const bDate = new Date(bStart).valueOf();
    return direction === "asc" ? aDate - bDate : bDate - aDate;
  };
};
export const sortByRunSheetStartTime = (direction: "asc" | "desc" = "asc") => {
  return (
    a: { runSheet?: { startTime?: string | null | undefined } | null | undefined },
    b: { runSheet?: { startTime?: string | null | undefined } | null | undefined },
  ): number => {
    const aStart = a?.runSheet?.startTime ? new Date(a?.runSheet?.startTime) : new Date();
    const bStart = b.runSheet?.startTime ? new Date(b.runSheet?.startTime) : new Date();
    const aDate = new Date(aStart).valueOf();
    const bDate = new Date(bStart).valueOf();
    return direction === "asc" ? aDate - bDate : bDate - aDate;
  };
};
export const sortByEventStartTime = (direction: "asc" | "desc" = "asc") => {
  return (a: { tEventStart?: string | null }, b: { tEventStart?: string | null }): number => {
    const aStart = a?.tEventStart ? new Date(a?.tEventStart) : new Date();
    const bStart = b.tEventStart ? new Date(b.tEventStart) : new Date();
    const aDate = new Date(aStart).valueOf();
    const bDate = new Date(bStart).valueOf();
    return direction === "asc" ? aDate - bDate : bDate - aDate;
  };
};
export const sortBySessionStartTime = (direction: "asc" | "desc" = "asc") => {
  return (a: { tSessionStart?: string | null }, b: { tSessionStart?: string | null }): number => {
    const aStart = a?.tSessionStart ? new Date(a?.tSessionStart) : new Date();
    const bStart = b.tSessionStart ? new Date(b.tSessionStart) : new Date();
    const aDate = new Date(aStart).valueOf();
    const bDate = new Date(bStart).valueOf();
    return direction === "asc" ? aDate - bDate : bDate - aDate;
  };
};
